module.exports = __webpack_public_path__ + "static/media/scroll.7b2296db.svg";